import React from "react";
import { useHistory } from "react-router-dom";
import { Package, ProductObject } from "types";
import { SecondaryButton } from "../Common/SecondaryButton";
import { ContentLayout } from "../Layout/ContentLayout";
import { ProductPhotoList } from "./ProductPhotoList";

export const PackagePhotoList = ({ pkg }: { pkg: Package }) => {
    const history = useHistory();
    const object = pkg.object as ProductObject.PACKAGE | ProductObject.PARTNER_PACKAGE;

    const redirectMap: { [key in ProductObject.PACKAGE | ProductObject.PARTNER_PACKAGE]: string } = {
        [ProductObject.PACKAGE]: "packages",
        [ProductObject.PARTNER_PACKAGE]: "partnerPackages",
    };

    const redirect = redirectMap[object] ?? null;

    const handleCancel = () => {
        history.push(`/products/${redirect}`);
    };

    return (
        <ContentLayout isWide>
            <ContentLayout.Section
                title="Photos"
                description="You can add a maximum of 10 .jpg, .png and .webp images to each package with a maximum size of 5 MB. Suggested pixel dimensions 1024x768"
            >
                <ProductPhotoList product={pkg} />
            </ContentLayout.Section>

            <ContentLayout.Footer preferenceSidebar>
                <SecondaryButton type="reset" onClick={handleCancel}>
                    Cancel
                </SecondaryButton>
            </ContentLayout.Footer>
        </ContentLayout>
    );
};
